<template>
  <div class="root">
  <pc-quick-start></pc-quick-start>
    <pc-viewing-trace-doc/>

  </div>
</template>

<script>
  import PcQuickStart from '../../views/documentation/quick-start.component'
  import PcViewingTraceDoc from './PcViewingTraceDoc'

  export default {
    name: 'quick-start.page',
    components: {
      PcQuickStart,PcViewingTraceDoc,
    }
  }
</script>

<style scoped>

</style>